import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Navbar.css';

const Navbar: React.FC = () => {
  const { isAuthenticated, user, logout } = useAuth();

  return (
    <nav className="navbar">
      <div className="navbar-brand">
        <Link to="/">
          <span>HOSPI</span><span className="navbar-brand-link">Link</span>
        </Link>
      </div>
      <ul className="navbar-menu">
        {isAuthenticated && (
          <>
            <li className="navbar-item">
              <NavLink to="/" end>
                Tableau de bord
              </NavLink>
            </li>
            <li className="navbar-item">
              <NavLink to="/appointments">
                Rendez-vous
              </NavLink>
            </li>
            <li className="navbar-item">
              <NavLink to="/templates">
                Modèles
              </NavLink>
            </li>
          </>
        )}
      </ul>
      <div className="navbar-auth">
        {isAuthenticated && (
          <>
            {/* Transforme le nom d'utilisateur en lien vers le profil */}
            <Link to="/profile" className="navbar-username-link">
              Bonjour, {user?.username}
            </Link>
            <button className="btn-logout" onClick={logout}>
              Déconnexion
            </button>
          </>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
